import { render, staticRenderFns } from "./TeamWorkSection.vue?vue&type=template&id=7c9f8943&scoped=true&"
import script from "./TeamWorkSection.vue?vue&type=script&lang=js&"
export * from "./TeamWorkSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9f8943",
  null
  
)

export default component.exports